import { render } from "./OrderReview.vue?vue&type=template&id=6bc85982&scoped=true"
import script from "./OrderReview.vue?vue&type=script&lang=js"
export * from "./OrderReview.vue?vue&type=script&lang=js"

import "./OrderReview.vue?vue&type=style&index=0&id=6bc85982&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/kds/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc85982"]])

export default __exports__